import React, { useState } from 'react';
import { Box, Typography, IconButton, DialogTitle, DialogContent } from '@mui/material';
import { 
  CreditCard, 
  Receipt, 
  Gift,
  ArrowLeft
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import PaymentIcon from '@mui/icons-material/Payment';
import DescriptionIcon from '@mui/icons-material/Description';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';

const Billing = () => {
  const navigate = useNavigate();

  const handleBackToPortal = () => {
    navigate('/portal');
  };

  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <DialogTitle sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        p: 2, 
        borderBottom: '1px solid #eee', 
        background: '#f7faff',
        minHeight: '64px'
      }}>
        <IconButton 
          edge="start" 
          color="inherit" 
          onClick={handleBackToPortal} 
          aria-label="back to portal" 
          sx={{ mr: 2 }}
        >
          <ArrowLeft />
        </IconButton>
        <img 
          src="/logo.png" 
          alt="Datafre8" 
          style={{ 
            height: '40px', 
            width: 'auto',
            cursor: 'pointer'
          }} 
        />
      </DialogTitle>

      {/* Content */}
      <DialogContent sx={{ p: 0, height: '100%', overflowY: 'auto', display: 'flex', flexDirection: 'row' }}>
        {/* Fixed Dropbox-style Left Panel */}
        <Box
          sx={{
            width: 260,
            height: '100vh',
            background: '#f7faff',
            borderRight: '1.5px solid #e3e8f0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            position: 'sticky',
            top: 0,
            zIndex: 2,
            boxShadow: '2px 0 8px 0 rgba(0,0,0,0.03)',
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700, px: 3, pt: 3, pb: 1, color: '#2D5EFF', letterSpacing: 1 }}>
            Billing
          </Typography>
          
          {/* Billing Options */}
          <DropboxPanelItem icon={<CreditCard size={20} style={{ color: '#2D5EFF' }} />} label="Subscription Plan" />
          <DropboxPanelItem icon={<PaymentIcon sx={{ color: '#2D5EFF' }} />} label="Payment Method" />
          <DropboxPanelItem icon={<DescriptionIcon sx={{ color: '#2D5EFF' }} />} label="Invoices" />
          <DropboxPanelItem icon={<CardGiftcardIcon sx={{ color: '#2D5EFF' }} />} label="Redeem Voucher" />
        </Box>

        {/* Main content area */}
        <Box sx={{ flex: 1, height: '100vh', background: '#fff', position: 'relative' }}>
          {/* Main content placeholder */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            height: '100%',
            flexDirection: 'column',
            gap: 2
          }}>
            <CreditCard size={64} color="#e0e0e0" />
            <Typography variant="h6" color="textSecondary">
              Select a billing option from the left panel
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Manage your subscription, payment methods, and billing history
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Box>
  );
};

// Helper Component
const DropboxPanelItem = ({ icon, label }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      px: 3,
      py: 1,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'rgba(45, 94, 255, 0.05)',
      },
    }}
  >
    <Box sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
      {icon}
    </Box>
    <Typography
      variant="body2"
      sx={{
        fontSize: '0.875rem',
        color: '#333',
      }}
    >
      {label}
    </Typography>
  </Box>
);

export default Billing; 